/**
 * 지표 스냅샷의 «숫자 필드» 이름 집합.
 *
 * `metric-day-detail` 과 `metric-reaction-stats` 가 둘 다 읽어서 따로 뒀다.
 */

/** 지표 스냅샷에서 숫자로 읽을 수 있는 필드 */
const METRIC_COUNT_FIELDS = [
  'likeCount',
  'commentCount',
  'viewCount',
  'savedCount',
  'shareCount',
  'downloadCount',
] as const;

type MetricCountField = (typeof METRIC_COUNT_FIELDS)[number];

export const isMetricCountField = (field: string): field is MetricCountField =>
  METRIC_COUNT_FIELDS.some((known) => known === field);
